import { withStyles } from '@material-ui/core/styles';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './AdminLoginFormControls.styles';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import { injectIntl, defineMessages } from 'react-intl';
import 'react-simple-keyboard/build/css/index.css';
import Keyboard from 'react-simple-keyboard';
import cSpinner from '../../../assets/images/cspinner.gif';

const messages = defineMessages({
  email: {
    id: 'Login.Email',
    defaultMessage: 'Email'
  },
  password: {
    id: 'Login.Password',
    defaultMessage: 'Password'
  },
  signin: {
    id: 'Login.SignIn',
    defaultMessage: 'Sign In'
  },
  forgotpassword: {
    id: 'Login.ForgotPassword',
    defaultMessage: 'Forgot Password?'
  },
  contactsupport: {
    id: 'Login.ContactSupport',
    defaultMessage: 'Contact Support'
  }
});

export class AdminLoginFormControls extends Component {
  constructor(props) {
    super(props);
    this.state = {
      maxlength: 100,
      SelectedInput: 'username',
      layoutName: 'default',
      username: '',
      password: ''
    };
  }
  static propTypes = {
    test: PropTypes.string,
    error: PropTypes.object
  };
  onChange = (input) => {
    if (this.state.SelectedInput) {
      document.querySelector('#' + this.state.SelectedInput).value = input;
      var event = new Event('change', { bubbles: true });
      event.simulated = true;
      document
        .querySelector('#' + this.state.SelectedInput)
        .dispatchEvent(event);
      this.change(this.state.SelectedInput, event);
    }
  };
  onKeyPress = (button) => {
    if (['{capslock}', '{shiftleft}', '{shiftright}'].includes(button))
      this.handleShiftButton();
  };
  handleShiftButton = () => {
    const {
      state: { layoutName }
    } = this;
    const shiftToggle = layoutName === 'default' ? 'shift' : 'default';
    this.setState({ layoutName: shiftToggle });
  };
  change = (name, e) => {
    let input = e.target.value;
    this.setState({ [e.target.name]: e.target.value }, () => {
      this.keyboard.setInput(input);
    });
    this.props.handleChange(e);
    this.props.setFieldTouched(name, true, false);
  };
  Focus = (obj) => {
    let ref = obj.target.name;
    if (this.keyboard) {
      this.setState({ SelectedInput: ref });
      this.setState({ maxlength: 100 });
      this.keyboard.setInput(document.querySelector('#' + ref).value);
    }
  };
  Blur = () => {
    //this.setState({ SelectedInput: '' });
  };

  forgotPassword = (e) => {
    this.props.onForgotPasswordRequest(this.props.values);
    e.preventDefault();
  };

  contactSupport = (e) => {
    this.props.onContactSupportRequest(this.props.values);
    e.preventDefault();
  };

  toogleDiv = () => {
    this.props.action();
  };
  render() {
    const { classes, intl } = this.props;
    const {
      // values: { username, password },
      errors,
      touched,
      handleSubmit,
      isValid,
      isInProgress
    } = this.props;

    return (
      <div>
        <form onSubmit={handleSubmit} className={classNames(classes.container)}>
          <TextField
            id="username"
            name="username"
            InputProps={{
              classes: {
                input: classes.textField
              }
            }}
            label={intl.formatMessage(messages.email)}
            autoComplete="off"
            autoCapitalize="false"
            autoFocus={this.state.SelectedInput === 'username' ? true : false}
            fullWidth
            //defaultValue={username}
            helperText={touched.username ? errors.username : ''}
            error={touched.username && Boolean(errors.username)}
            onChange={this.change.bind(null, 'username')}
            onFocus={this.Focus.bind('username')}
            onBlur={this.Blur.bind('username')}
            value={this.state.username}
          />
          <TextField
            id="password"
            name="password"
            InputProps={{
              classes: {
                input: classes.textField
              }
            }}
            label={intl.formatMessage(messages.password)}
            autoFocus={this.state.SelectedInput === 'password' ? true : false}
            fullWidth
            type="password"
            autoComplete="off"
            autoCapitalize="false"
            // defaultValue={password}
            helperText={touched.password ? errors.password : ''}
            error={touched.password && Boolean(errors.password)}
            onChange={this.change.bind(null, 'password')}
            onFocus={this.Focus.bind('password')}
            onBlur={this.Blur.bind('password')}
            value={this.state.password}
          />
          <div className={classNames(classes.formFooter)}>
            <p
              onClick={this.toogleDiv}
              className={classNames(classes.togglerP)}
            >
              Login with Secure Badge
            </p>
            <Button
              type="submit"
              fullWidth
              color="primary"
              variant="contained"
              className={
                !isValid || isInProgress
                  ? classNames(classes.disabledPrimaryButton)
                  : classNames(classes.primaryButton)
              }
              disabled={!isValid || isInProgress}
            >
              {isInProgress ? (
                <img
                  src={cSpinner}
                  style={{ width: '30px' }}
                  alt="In Process"
                />
              ) : (
                intl.formatMessage(messages.signin)
              )}
            </Button>
          </div>
          <div className={classNames(classes.linkContainer)}>
            {/* <button
                className={classNames(classes.buttonLink)}
                onClick={this.forgotPassword.bind()}
              >
                {intl.formatMessage(messages.forgotpassword)}
              </button> */}
          </div>
        </form>

        <div className={classNames(classes.simpleKeyboard)}>
          <Keyboard
            keyboardRef={(r) => (this.keyboard = r)}
            layoutName={this.state.layoutName}
            maxLength={{ default: this.state.maxlength }}
            layout={{
              default: [
                '` 1 2 3 4 5 6 7 8 9 0 - = {backspace}',
                'q w e r t y u i o p [ ] \\',
                "{capslock} a s d f g h j k l ; '",
                'z x c v b n m , . /',
                '.com @ {space}'
              ],
              shift: [
                '~ ! @ # $ % ^ & * ( ) _ + {backspace}',
                'Q W E R T Y U I O P { } |',
                '{capslock} A S D F G H J K L : "',
                'Z X C V B N M < > ?',
                '.com @ {space}'
              ]
            }}
            onChange={(input) => this.onChange(input)}
            onKeyPress={(button) => this.onKeyPress(button)}
          />
        </div>
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(
  injectIntl(AdminLoginFormControls)
);
